import { toast } from 'sonner';

/** Standardized toast durations (ms) */
const DURATIONS = {
  success: 3000,
  error: 6000,
  warning: 4000,
  info: 4000,
} as const;

/**
 * Centralized toast helper using Sonner.
 *
 * @example
 * ```ts
 * import { showToast } from '@/lib/toast';
 *
 * showToast.success(intl.formatMessage({ id: 'properties.toast.created.title' }), intl.formatMessage({ id: 'properties.toast.created.description' }));
 * showToast.error(intl.formatMessage({ id: 'common.error' }));
 * ```
 */
export const showToast = {
  success: (message: string, description?: string) =>
    toast.success(message, { duration: DURATIONS.success, description }),

  error: (message: string, description?: string) =>
    toast.error(message, { duration: DURATIONS.error, description }),

  warning: (message: string, description?: string) =>
    toast.warning(message, { duration: DURATIONS.warning, description }),

  info: (message: string, description?: string) =>
    toast.info(message, { duration: DURATIONS.info, description }),

  /** For async operations with loading → success / error states */
  promise: <T>(
    promise: Promise<T>,
    msgs: { loading: string; success: string; error: string },
  ) => toast.promise(promise, msgs),
};
